export default {
  // detail list
  'dict.detail.title': '字典详情',
  'dict.detail.query.dictKey': '字典KEY',
  'dict.detail.query.dictKey.placeholder': '请输入字典KEY',
  'dict.detail.column.dictLabel': '字典Label',
  'dict.detail.column.dictValue': '字典Value',
  'dict.detail.column.sortNum': '字典排序',
  'dict.detail.column.status': '是否启用',
  'dict.detail.column.status.normal': '正常',
  'dict.detail.column.status.disable': '禁用',
  'dict.detail.column.remark': '备注',
  'dict.detail.confirm.delete.title': '确定要删除字典"{dictLabel}"吗？',
  'dict.detail.confirm.delete.batch.title': '确定要删除选中的{length}个字典吗？',
  // detail edit
  'dict.detail.edit.title': '修改字典',
  'dict.detail.add.title': '新增字典',
  'dict.detail.edit.form.dictLabel': '字典Label',
  'dict.detail.edit.form.dictLabel.placeholder': '请输入字典Label',
  'dict.detail.edit.form.dictLabel.required': '请输入字典Label',
  'dict.detail.edit.form.dictValue': '字典Value',
  'dict.detail.edit.form.dictValue.placeholder': '请输入字典VALUE',
  'dict.detail.edit.form.dictValue.required': '请输入字典VALUE',
  'dict.detail.edit.form.sortNum': '字典排序',
  'dict.detail.edit.form.sortNum.required': '请输入字典排序',
  'dict.detail.edit.form.status': '字典状态',
  'dict.detail.edit.form.status.normal': '正常',
  'dict.detail.edit.form.status.disable': '停用',
  'dict.detail.edit.form.status.required': '请选择字典状态',
  'dict.detail.edit.form.remark': '备注',
  'dict.detail.edit.form.remark.placeholder': '请输入备注',
  // list
  'dict.query.dictKey': '字典KEY',
  'dict.query.dictKey.placeholder': '输入字典KEY',
  'dict.column.dictKey': '字典KEY',
  'dict.column.remark': '备注',
  'dict.column.status': '是否启用',
  'dict.column.status.normal': '正常',
  'dict.column.status.disable': '禁用',
  'dict.column.operation.detail': '详情',
  'dict.confirm.delete.batch.title': '确定删除选中的{length}个字典吗？',
  'dict.confirm.delete.title': '确定要删除字典"{dictKey}"吗？',
  // edit
  'dict.edit.title': '修改字典',
  'dict.add.title': '新增字典',
  'dict.add.success': '新增成功',
  'dict.edit.success': '修改成功',
  'dict.edit.form.dictKey': '字典KEY',
  'dict.edit.form.dictKey.placeholder': '请输入字典KEY',
  'dict.edit.form.dictKey.required': '请输入字典KEY',
  'dict.edit.form.status': '字典状态',
  'dict.edit.form.status.normal': '正常',
  'dict.edit.form.status.disable': '停用',
  'dict.edit.form.status.required': '请选择字典状态',
  'dict.edit.form.remark': '备注',
  'dict.edit.form.remark.placeholder': '请输入备注',
}
